import React from 'react';
import {Button, Col, Layout, Row} from "antd";
import {Content} from "antd/es/layout/layout";
import {left_text, right_text} from "./text";
import img_0 from './images/Header without text.webp'
import img_1 from './images/Portal Image no line.webp'
import img_2 from './images/Curated Image no line.webp'
import img_3 from './images/Reseller Image no line.webp'
import './style.scss'

const ProHome = (props) => {
    return (
        <Layout>
            <Content>
                <Row justify={"center"}>
                    <div className="image-overlay-container">
                        <img src={img_0} alt="Business Ambiance" className="y-background-image"/>
                        <div className="overlay-content">
                            <p className={'pro-h1'}>Elevate your business ambience</p>
                            <p className={'pro-h2'}>with exquisite artwork</p>
                            <p className="overlay-subtext">Create a captivating atmosphere and transform your business
                                surroundings with our Textura Pro digital canvas.</p>
                            <Button className="learn-more-button pro-btn-hover-to-white"
                                    onClick={() =>
                                        window.location.href = '/business/textura-pro'
                                    }>
                                Learn more
                            </Button>
                        </div>
                    </div>
                </Row>
                <Row justify={"center"} style={{
                    columnGap: '4rem',
                    margin: '-24vh 0 0 0'
                }}>
                    <Col lg={8}>
                        {left_text.map((txt, idx) =>
                            <p className={'pro-home-txt'} key={idx}>
                                {txt}
                            </p>
                        )}
                    </Col>
                    <Col lg={8}>
                        {right_text.map((txt, idx) =>
                            <p className={'pro-home-txt'} key={idx}>
                                {txt}
                            </p>
                        )}
                    </Col>
                </Row>
                <Row justify={"center"} className={'j-section'}>
                    <img src={img_1} className={'j-img'}></img>
                    <div className="j-text-overlay">
                        <p className={'j-h1'}>Vieunite Pro Portal</p>
                        <div className="j-white-line"></div>
                        <p className={'j-txt'}>This is your hub for seamless artwork management.
                            Effortlessly control displayed artwork, curate playlists, and adjust your space's ambiance.
                            By having full control of your digital canvas and access to curated collections of artwork,
                            you can simplify your workflow and elevate your environment with Vieunite Pro.</p>
                        <Button
                            onClick={_ =>
                                window.location.href = '/business/prologin'}
                            className="j-overlay-button pro-btn-hover-to-white ">
                            Learn more
                        </Button>
                    </div>
                </Row>
                <Row justify={"center"} className={'j-section'}>
                    <img src={img_2} className={'j-img'}></img>
                    <div className="j-text-overlay">
                        <p className={'j-h1'}>Curated Collections</p>
                        <div className="j-white-line"></div>
                        <p className={'j-txt'}>With Textura Pro you have access to a curated selection of artwork playlists, meticulously crafted by our specialist team.
                            We can customise playlists based on environments, business spaces, or specific business needs and preferences, ensuring your space is always perfectly curated.</p>
                        <Button
                            onClick={_ =>
                                window.location.href = '/business/curated-collections'}
                            className="j-overlay-button pro-btn-hover-to-white ">
                            Discover more
                        </Button>
                    </div>
                </Row>

                <Row justify={"center"} className={'j-section'}>
                    <img src={img_3} className={'j-img'}></img>
                    <div className="j-text-overlay">
                        <p className={'j-h1'}>Become a Reseller Partner</p>
                        <div className="j-white-line"></div>
                        <p className={'j-txt'}>Discover the benefits of becoming a reseller for the Textura Pro digital canvas. Elevate your business, captivate your customers and lead the way in visual storytelling. Partner with Vieunite Pro to access competitive pricing, marketing support and exclusive product offerings.</p>
                        <Button
                            onClick={_ =>
                                window.location = "mailto:support@vieunite.com"}
                            className="j-overlay-button pro-btn-hover-to-white ">
                            Get in touch
                        </Button>
                    </div>
                </Row>
            </Content>
        </Layout>
    )
}

export default ProHome;
